import styled from 'styled-components'
import { grey } from '../../theme/palette'
import { MOBILE, WIDE_SCREEN } from 'constants/breakpoints'

export const EmployeeItem = styled.div`
  padding: 0.3rem;
  border: 1px solid ${grey};
  margin: 0.3rem;
  cursor: pointer;
  font-size: 16px;
  text-align: center;
  max-width: 100%;
  word-break: break-word;
  @media only screen and (min-width: ${WIDE_SCREEN}) {
    font-size: 24px;
  }
`
export const EmployeeContainer = styled.div`
  padding: 0.3rem;
  border: 1px solid ${grey};
  margin: 0.3rem;
`
export const Container = styled.div`
  max-height: 500px;
  overflow: auto;
  @media only screen and (max-width: ${MOBILE}) {
    padding-right: 0.5rem;
    max-height: 550px;
  }
  @media only screen and (min-width: ${WIDE_SCREEN}) {
    max-height: 900px;
  }
`
export const SortButton = styled.div`
  cursor: pointer;
  margin-left: 5px;
  @media only screen and (min-width: ${WIDE_SCREEN}) {
    margin-left: 10px;
    margin-bottom: 10px;
  }
`
